import Date from "./date";

export default Date;
